import jQuery from 'jquery';
let $ = jQuery;

/**
* class HSN.Flyout
*
* Encapsulates the functionality of a menu that pops up when another UI
* element is hovered.
**/
HSN.Flyout = function (config) {
    /**
    * new HSN.Flyout(config)
    * - config (Object): A configuration object for the [[HSN.Flyout]]
    *   consisting of the following keys:
    *   - closer (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as a close button for the flyout.
    *   - closeClass (string): CSS classes to be added to the Flyout's close button.
    *   - closeTag (string): The HTML tag to use for the Flyout's close button if no closer is provided. Defaults to span.
    *   - trigger (HTMLElement): The HTML element that should be the trigger for opening & closing the flyout.
    *   - flyout (HTMLElement): The HTML element that should be shown and hidden when the trigger is interacted with.
    *   - triggerEvent (HSN.Flyout.TRIGGER_EVENT): The event that should trigger opening of the flyout. Defaults to [[HSN.Flyout.TRIGGER_EVENT.HOVER]]
    *   - noajax (boolean): Turns off the flyout Open function for pages where ajax will not be available.
    *   - relocateFlyout (boolean): If true, repositions flyout inside trigger element.
    *   - timeout (integer): milliseconds to wait before closing flyout after leaving trigger area
    *   - isSetContainerHtmlOnHide (boolean): if true the flyout container html will be replaced by the value in htmlForContainerOnHide
    *   - htmlForContainerOnHide (string): html to set the flyout container too when isSetContainerHtmlOnHide is true
    **/
    var __scope = this;

    this.config = (config = config || {});
    config.closeTag = (config.closeTag = config.closeTag || 'span');
    config.triggerEvent = (config.triggerEvent = config.triggerEvent || HSN.Flyout.TRIGGER_EVENT.HOVER);

    this.Cacheable = (config.cacheable = config.cacheable || false);
    this.Events = new HSN.EventCoordinator();
    this.Trigger = $(config.trigger);
    this.Flyout = $(config.flyout);
    this.Url = config.url;
    this.NoAjax = config.noajax;
    this.RelocateFlyout = config.relocateFlyout;
    this.Timeout = "timeout" in config ? config.timeout : 350;
    this.DisableHover = config.disableHover;
    this.IsSetContainerHtmlOnHide = config.isSetContainerHtmlOnHide;
    this.HtmlForContainerOnHide = (config.htmlForContainerOnHide = config.htmlForContainerOnHide) || '';
    this.SetInvisible = config.setInvisible;
    this.AjaxData = config.ajaxData || {};
    this.IsPost = config.isPost || false;
    this.matchWindowHeight = config.matchWindowHeight || false;
    this.disableScrolling = config.disableScrolling || false;
    this.setMask = config.setMask || false;

    if (config.closer) {
        __scope.Closer = $(config.closer);
    }
    else {
        __scope.Closer = $('<' + config.closeTag + '>Close</' + config.closeTag + '>');
    }

    __scope.Closer.on('click', function (e) {
        e.preventDefault();
        __scope.Close();
        return false;
    });

    __scope.Closer.addClass('close');

    if (config.closeClass) {
        __scope.Closer.addClass(config.closeClass);
    }

    if (!config.closer) {
        this.Flyout.append(__scope.Closer);
    }

    switch (config.triggerEvent) {
        case HSN.Flyout.TRIGGER_EVENT.CLICK:
            this.Trigger.on('click', function (e) {
                e.preventDefault();
                if (Modernizr.touchevents) {
                    __scope.Trigger.off('click');
                }

                var scope = this;
                switch (__scope.GetState()) {
                    case HSN.Flyout.STATE.CLOSED:
                        __scope.Open(scope);
                        break;
                    case HSN.Flyout.STATE.OPEN:
                        __scope.Close(scope);
                }
                return false;
            });
            break;
        case HSN.Flyout.TRIGGER_EVENT.TOUCH:
            this.Trigger.on('touchend', function (e) {
                e.preventDefault();

                var scope = this;
                switch (__scope.GetState()) {
                    case HSN.Flyout.STATE.CLOSED:
                        __scope.Open(scope);
                        break;
                    case HSN.Flyout.STATE.OPEN:
                        __scope.Close(scope);
                }
                return false;
            });
            break;
        case HSN.Flyout.TRIGGER_EVENT.HOVER:
            if (!this.DisableHover) {
                this.Trigger.on('mouseenter', function (e) {
                    var scope = this;
                    var flyout = __scope.Flyout;

                    var timeout = flyout.data('_HSN.Flyout.MouseLeaveTimeout');
                    if (timeout) {
                        clearTimeout(timeout);
                        flyout.data('_HSN.Flyout.MouseLeaveTimeout', null);
                    }

                    flyout.data(
                        '_HSN.Flyout.MouseEnterTimeout',
                        setTimeout(
                            function () {
                                __scope.Open(scope);

                                if (__scope.config.onOpenCallback)
                                    __scope.config.onOpenCallback();
                            },
                            __scope.Timeout
                        )
                    );

                });
                this.Trigger.on('mouseleave', this.triggers, function (e) {
                    var flyout = __scope.Flyout;
                    var scope = this;

                    var timeout = flyout.data('_HSN.Flyout.MouseEnterTimeout');
                    if (timeout) {
                        clearTimeout(timeout);
                        flyout.data('_HSN.Flyout.MouseEnterTimeout', null);
                    }

                    flyout.data('_HSN.Flyout.MouseLeaveTimeout', setTimeout(
                        function () {
                            __scope.Close(scope);

                            if (__scope.config.onCloseCallback)
                                __scope.config.onCloseCallback();
                        },
                        __scope.Timeout
                    ));

                });
            }
            break;

        case HSN.Flyout.TRIGGER_EVENT.CLICKHOVER:
            this.Trigger.on('click', function (e) {
                e.preventDefault();
                if (Modernizr.touchevents) {
                    __scope.Trigger.off('click');
                }

                var scope = this;
                switch (__scope.GetState()) {
                    case HSN.Flyout.STATE.CLOSED:
                        __scope.Open(scope);
                        break;
                    case HSN.Flyout.STATE.OPEN:
                        __scope.Close(scope);
                }

                return false;
            });

            if (!this.DisableHover) {
                this.Trigger.on('mouseleave', this.triggers, function (e) {
                    var scope = this;
                    return false;
                });

                this.Flyout.on('mouseleave', this.triggers, function (e) {
                    var flyout = __scope.Flyout;
                    var scope = this;

                    var timeout = flyout.data('_HSN.Flyout.MouseEnterTimeout');
                    if (timeout) {
                        clearTimeout(timeout);
                        flyout.data('_HSN.Flyout.MouseEnterTimeout', null);
                    }

                    flyout.data('_HSN.Flyout.MouseLeaveTimeout', setTimeout(
                        function () {
                            __scope.Close(scope);
                        },
                        __scope.Timeout
                    ));
                });
            }

            break;

        case HSN.Flyout.TRIGGER_EVENT.TOUCH_WITH_CLOSE:
            this.Trigger.on('touchend',{
                    context : __scope
                },
                __scope.OnTouchWithClose);
               
            break;
    }
};

/**
* HSN.Flyout.EVENT = Object
*
* An enumeration of events an [[HSN.Flyout]] can raise:
* - BEFORE_OPEN: Right before the flyout is opened.
* - BEFORE_CLOSE: Right before the flyout is opened.
**/
HSN.Flyout.EVENT = {
    BEFORE_CLOSE: 'flyout:before_close',
    BEFORE_OPEN: 'flyout:before_open',
    AFTER_LOAD: 'flyout:after_load'
};

/**
* HSN.Flyout.STATE = Object
*
* An enumeration of possible states that the flyout can have, with the following members:
* - CLOSED: The flyout is currently closed.
* - OPEN: The flyout is currently open.
**/
HSN.Flyout.STATE = {
    CLOSED: false,
    OPEN: true
};

/**
* HSN.Flyout.TRIGGER_EVENT = Object
*
* An enumeration of possible events that can trigger a flyout to open, with the following members:
* - CLICK: Opens the flyout on click.
* - HOVER: Opens the flyout on mouse enter, closes the flyout on mouse leave.
* - CLICKHOVER: Opens the flyout on [trigger] click, closes the flyout on [flyout] mouse leave.
**/
HSN.Flyout.TRIGGER_EVENT = {
    CLICK: 1,
    HOVER: 2,
    TOUCH: 3,
    CLICKHOVER: 4,
    TOUCH_WITH_CLOSE: 5
};

HSN.Flyout.prototype = {
    _state: HSN.Flyout.STATE.CLOSED,

    /**
    * HSN.Flyout#Events -> HSN.EventCoordinator
    *
    * Provides access to the [[HSN.EventCoordinator]] instance that the
    * flyout uses to raise it's events.
    **/
    Events: null,

    /**
    * HSN.Flyout#Flyout -> jQuery
    *
    * [[HSN.Flyout#Flyout]] provides access to the jQuery-wrapped HTML element that is the flyout.
    **/
    Flyout: null,

    /**
    * HSN.Flyout#Trigger -> jQuery
    *
    * [[HSN.Flyout#Trigger]] provides access to the jQuery-wrapped HTML element that is the flyout trigger.
    **/
    Trigger: null,

    /**
    * HSN.Flyout#Close -> void
    *
    * [[HSN.Flyout#Close]] closes the flyout and sets proper state on all related elements.
    **/
    Close: function (trigger) {
        if (this._state === HSN.Flyout.STATE.CLOSED) {
            return;
        }

        this.Events.Trigger(HSN.Flyout.EVENT.BEFORE_CLOSE, this);
        HSN.Instance().Events.Trigger(HSN.Flyout.EVENT.BEFORE_CLOSE);
        this.Flyout.hide();
        if (this.IsSetContainerHtmlOnHide) {
            this.Flyout.html(this.HtmlForContainerOnHide);
        }
        if (this.RelocateFlyout) {
            $(this.Flyout, this.Trigger).remove();
            $('.arrow', this.Trigger).remove();
            this.Trigger.removeClass('flyout-container');
        }
        $(this.Trigger).removeClass('active');
        this._state = HSN.Flyout.STATE.CLOSED;

        $('.video-flash').css('visibility', 'visible');

        if (this.disableScrolling) {
            $('html, #torso').css({ 'overflow': '' });
            $('#torso').css({ 'position': '' });
        }
        if(this.setMask) {
            $('#modal-mask').remove();
        }

        $('.flyout-container.v2').hide();
    },

    /**
    * HSN.Flyout#GetState() -> HSN.Flyout.STATE
    *
    * [[HSN.Flyout#GetState]] returns the appropriate [[HSN.Flyout.STATE]] value to indicate whether the flyout is currently open or closed.
    **/
    GetState: function () {
        return this._state;
    },

    /**
    * HSN.Flyout#Open -> void
    *
    * [[HSN.Flyout#Open]] opens the flyout and sets proper state on all related elements.
    **/
    Open: function (trigger, forceOpen, noAnimate) {
        var __scope = this;
        var $trigger = $(trigger);

        $('.video-flash').css('visibility', 'hidden');

        if ((typeof noAnimate == "undefined") || noAnimate == null) {
            noAnimate = true;
        }

        if ((!forceOpen && this._state === HSN.Flyout.STATE.OPEN)
            || (this.NoAjax && (typeof (__scope.Url) !== "undefined"))) {
            return;
        }

        $('.flyout-container.v2').show();

        this.Events.Trigger(HSN.Flyout.EVENT.BEFORE_OPEN, this);
        HSN.Instance().Events.Trigger(HSN.Flyout.EVENT.BEFORE_OPEN);
        $trigger.addClass('active');
        if (this.RelocateFlyout) {
            $trigger.addClass('flyout-container');
            var relocatedFlyout = this.Flyout.appendTo($trigger);
            var arrow = $('<div class="arrow"></div>').appendTo($trigger);
            this.Flyout.css({
                'top': -((this.Flyout.height()) + ($trigger.height())) + 6,
                'left': -((this.Flyout.width() / 4) + ($trigger.width() / 4))
            });
            arrow.css({
                'top': -$trigger.height() + 6,
                'left': $trigger.width() / 3
            });
            relocatedFlyout.show();
        }
        else {
            if (noAnimate) {
                this.Flyout.show();
            }
            else {
                this.Flyout.stop(true, true).fadeIn({ duration: 250, queue: false }).css('display', 'none').slideDown(250);
            }
        }

        if (this.SetInvisible) {
            this.Flyout.css('visibility', 'hidden');
        }
        if (this.matchWindowHeight) {
            this.Flyout.css('height', '100%');
        }
        if (this.disableScrolling) {
            $('html, #torso').css({ 'overflow': 'hidden' });
            $('#torso').css({ 'position': 'fixed' });
        }
        if (this.setMask) {
            if (!$('#modal-mask').is(':visible')) {
                $('<div></div>').prependTo('#torso').attr('id', 'modal-mask').addClass('lower-mask');
            }

            if (!$('.modal').hasClass('no-mask') && !$('#modal-mask').is(':visible')) {
                $('#modal-mask').css('height', $('body').height());
                $('#modal-mask').show();
            }
        }

        this._state = HSN.Flyout.STATE.OPEN;

        if (typeof (__scope.Url) === "undefined") {
            return;
        }


        //Call for asynchronously loaded flyouts, which have url specified
        $.ajax(
            __scope.Url,
            {
                type: __scope.IsPost ? "POST" : "GET",
                cache: __scope.Cacheable,
                context: __scope,
                data: __scope.AjaxData,
                dataType: 'html',
                success: function (data, status, xhr) {
                    __scope.Flyout.html(data);//.show();

                    //TODO: wrap this in a coremetrics check
                    cX("onload");

                    __scope.Flyout.append(__scope.Closer);

                    //TODO: check if can avoid rewiring close callback from above
                    __scope.Closer.on('click', function (e) {
                        e.preventDefault();
                        __scope.Close();
                        return false;
                    });

                    __scope.Events.Trigger(HSN.Flyout.EVENT.AFTER_LOAD, __scope);
                },
                error: function (xhr, status, error) {
                    if (xhr.readyState === 0 && xhr.status === 0) {
                        return;
                    }
                    alert("Unfortunately there was an error attempting to load the content, please try again.");
                }
            }
        );
    },

    SetUrl: function (url) {
        this.Url = url;
    },

    RemoveHandlers: function () {
        this.Trigger.off();
    },

    OnTouchWithClose: function(e) {
        e.preventDefault();
        var context = e.data.context;
        var scope = this;
        //turn off so flyout can appear
        context.Trigger.off('touchend');
           
        switch (context.GetState()) {
            case HSN.Flyout.STATE.CLOSED:
                context.Open(scope);   
                break;

            case HSN.Flyout.STATE.OPEN:
                context.Close(scope);
        }

        //close on tap outside of element
        $('html').on('touchend', function (e) {
            if ($(e.target).parents('.flyout-container').length === 0 &&
                context.GetState() === HSN.Flyout.STATE.OPEN) {

                //turn back on touch event so flyout can be interacted with
                context.Trigger.on('touchend', {
                    context: context
                }, context.OnTouchWithClose);

                context.Close(scope);

                return false;
            }    
            return true;
        });
    }
};



// WEBPACK FOOTER //
// ./assets/js/HSN/Flyout.js